export default __webpack_public_path__ + "static/media/loader.09c36e37.gif";